import { AppWindow, LogIn, ShieldCheck } from "lucide-react";

// The Applications product: AuthNull signs users in to the tenant's own apps
// (OpenID Connect, SAML) or gives them a second factor (MFA API).
const mfaApplicationsNavigation = [
  {
    key: "/pam/applications",
    icon: <AppWindow className="icon" />,
    label: "Applications",
    navigate: "/pam/applications",
  },
  {
    key: "/pam/applications/signInSource",
    icon: <LogIn className="icon" />,
    label: "Sign-in source",
    navigate: "/pam/applications/signInSource",
  },
  {
    // The shared logs screen; AuthLogsIndex limits it to oidc / saml / mfa_api.
    key: "/pam/auth-logs",
    icon: <ShieldCheck className="icon" />,
    label: "Sign-in logs",
    navigate: "/pam/auth-logs",
  },
];

export default mfaApplicationsNavigation;
